exports = module.exports = require("../../../../css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".video-controls{height:34px;background-color:rgba(0,0,0,.8);display:-ms-flexbox;display:flex}.video-controls button{background:none;border:none;margin:0;color:#fff}.video__control{position:relative;padding:10px;height:100%;font-size:14px;box-sizing:border-box}.video-controls button:focus,.video__control--focused,.video__control:focus{outline:thin dotted}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/react-html5video/src/components/controls/controls.css
// module id = 1371
// module chunks = 0